const passwordStreight = {
  mustContain: 'A senha deve conter:',
  hasLowerCase: 'Caractere minúsculo',
  hasUpperCase: 'Caractere maiúsculo',
  hasNumbers: 'Número',
  hasSpecificSymbol: 'Símbolos #$%^@',
  hasMinMaxLength: 'No mínimo 6 caracteres',
};

export default passwordStreight;
